export const MS_DEFENDER_SUBSCRIPTION_ANNOTATION = 'msdefender/subscription';